<template>
  <div id="plan_1F">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/plan_1F.jpg'); height:50vh; background-position:0px 40%">
          <div class="container">
              <div class="row">
              <div class="col-md-8 ml-auto mr-auto">
                  <div class="brand text-center">
                  <h1 class="title" id="hide_edit" @click="edit_plan_1F">空間介紹一樓</h1>
                  <h3 class="title description">1 Floor</h3>
                  </div>
              </div>
              </div>
          </div>
      </div>
      <div class="main">
          <div class="container">
            <div class="section text-center">
              <div class="row">
                <div class="col">
                  <!-- <img src="static/img/smc1F-1.svg"> -->
                  <img style="width:100%" src="static/img/introduction/1F-D201_cropped.svg">
                </div>
              </div>
            </div>
            <template v-for="(item, index) in data">
              <div class="row" :key="index">
                <div class="card">
                  <div class="row">
                    <div class="col-md-5 col-12">
                      <div class="card-header card-header-image">
                        <div :id="'carousel_'+ index" class="carousel slide" data-ride="carousel">
                          <div class="carousel-inner">
                            <template v-for="(pic, pic_i) in item.pic_list">
                              <div :class="['carousel-item', pic_i == 0 ? 'active':'']" :key="pic_i">
                                <!-- <img class="d-block" style="max-height: 280px; margin:auto;" :src="pic | imgUrl" alt="First slide"> -->
                                <img class="d-block" style="max-height: 280px; margin:auto;" :src="pic" alt="First slide">
                              </div>
                            </template>
                          </div>
                          <a class="carousel-control-prev" style="top:50%" :href="'#carousel_'+ index" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                          </a>
                          <a class="carousel-control-next" style="top:50%" :href="'#carousel_'+ index" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <!-- order-lg-first 會讓效果反向出現 -->
                    <div :class="['col-md-7 col-12', index%2 == 0? '':' order-lg-first']">
                      <div class="card-body">
                        <h4 class="card-title">{{ item.room_name_cht }} <template v-if="item.room_no != -1">({{ item.room_no }})</template> </h4>
                        <h6 class="card-category">{{ item.room_name_eng }}</h6>
                        <hr>
                        <p class="card-description text-muted">
                          {{ item.description_cht }}
                        </p>
                        <p class="card-description">
                          {{ item.description_eng }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!-- <div class="row">
              <div class="card">
                <div class="row">
                  <div class="col-md-5 col-12">
                    <div class="card-header card-header-image">
                      <div id="carousel_1" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img class="d-block" style="max-height: 285px; margin:auto;" src="/static/img/introduction/智慧製造示範產線區-1.jpg" alt="First slide">
                          </div>
                          <div class="carousel-item">
                            <img class="d-block" style="max-height: 285px; margin:auto;" src="/static/img/introduction/智慧製造示範產線區-2.jpg" alt="Second slide">
                          </div>
                        </div>
                        <a class="carousel-control-prev" style="top:50%" href="#carousel_1" role="button" data-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" style="top:50%" href="#carousel_1" role="button" data-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="sr-only">Next</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7 col-12">
                    <div class="card-body">
                      <h4 class="card-title">產學合作智能設備區</h4>
                      <h6 class="card-category">Industry-University Cooperative Research Area</h6>
                      <hr>
                      <p class="card-description text-muted">
                        具有MuCell發泡成型機、高速成型機，提供學生良好之實驗研究場所。
                      </p>
                      <p class="card-description">
                        With MuCell foam molding machine, high-speed molding machine, to provide students with a good place for experimental research.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- order-lg-first 會讓效果反向出現 -->
            <!-- <div class="row">
              <div class="card">
                <div class="row">
                  <div class="col-md-5 col-12">
                    <div class="card-header card-header-image">
                      <a href="#pablo">
                        <img class="img" src="/static/img/introduction/智慧製造示範產線區-2.jpg" />
                      </a>
                    </div>
                  </div>
                  <div class="col-md-7 col-12 order-lg-first">
                    <div class="card-body">
                      <h4 class="card-title">智慧製造示範產線區</h4>
                      <h6 class="card-category text-muted">Founder</h6>
                      <p class="card-description">
                        Don't be scared of the truth because we need to restart the human foundation in truth...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "plan_1F",
  props: [],
  data() {
    return {
      data:[]
    };
  },
  methods: {
    getData: function(){
      var vm = this;
      axios
        .post(`/api/getfloorInfo`,{
          floor: 1
        })
        .then(res => {
          var data = res.data.data;
          // console.log(data)
          for(var i = 0; i < data.length; i++){
            var pic = data[i].img;
            var pic_list = [];
            if(pic != null && pic != '' && pic != 'null'){
              var pic_arr = pic.split('@');
              var pic_len = pic.split('@').length;
              
              if(pic_len > 1){
                for(var j = 0; j < pic_len; j++){
                  pic_list.push(pic_arr[j])
                }
              }
              else{
                pic_list.push(pic)
              }
            }
            

            vm.data.push({
              id: data[i].id,
              room_no: data[i].room_no,
              room_name_cht: data[i].room_name_cht,
              room_name_eng: data[i].room_name_eng,
              description_cht: data[i].description_cht,
              description_eng: data[i].description_eng,
              pic_list:pic_list
            })
          }
          // vm.data = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    edit_plan_1F: function(){
      var vm = this;
      document.querySelector('#hide_edit').addEventListener('click', function (evt) {
          // console.log(evt.detail)

          if(evt.detail === 3){
              vm.$router.push("/about/edit_plan_1F").catch(error => {
                  if (error.name != "NavigationDuplicated") {
                      throw error;
                  }
              });
          }
      });
    }
  },
  filters: {
    imgUrl: function(value) {
      if(value != null || value != 'null' || value != ''){
        value = "/static/img/introduction/" + value + ".jpg";
      }
      else{
        value = "/static/img/image_placeholder.jpg";
      }
      
      return value;
    }
  },
  computed: {},
  created() {
    this.getData();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/plan_1F.vue